// CTA with Javascript action
// Javascript actions defined here relate to a Standard CTA component (with ctaType of 'CTA with Javascript action')
// using their contentful_id and are triggered on click events for that CTA
const actions = {
  england: {
    '5oLVvLJXNGsRb9zyefmGUm': () => window.CookieControl.open(),
  },
  scotland: {
    '5oLVvLJXNGsRb9zyefmGUm': () => window.CookieControl.open(),
  },
};

export default actions;
